module.exports = __webpack_public_path__ + "img/logo.04a0b2f1.png";